import { keepPreviousData } from '@tanstack/vue-query';
import type { Ref } from 'vue';
import { computed } from 'vue';

/** Shared defaults: show cached data immediately, refetch in the background on each visit. */
export const ENTITY_LIST_QUERY_OPTIONS = {
  staleTime: 10 * 60 * 1000,
  gcTime: 24 * 60 * 60 * 1000,
  refetchOnMount: 'always' as const,
  refetchOnWindowFocus: true,
  placeholderData: keepPreviousData,
};

/** Full-page loader: only when there is no cached data yet (not during background refetch). */
export function useQueryInitialLoading(
  isLoading: Ref<boolean>,
  data: Ref<unknown[] | undefined>,
) {
  return computed(() => isLoading.value && !data.value?.length);
}
